export default function initLightbox() {
    const galleryEl = document.querySelector('[data-gf-gallery]');
    if (!galleryEl) return;

    const modal = document.getElementById('gf-lightbox');
    if (!modal) return;

    const viewport = modal.querySelector('[data-gf-lightbox-viewport]');
    const caption = modal.querySelector('[data-gf-lightbox-caption]');
    const btnPrev = modal.querySelector('[data-gf-lightbox-prev]');
    const btnNext = modal.querySelector('[data-gf-lightbox-next]');

    // collect items
    const items = Array.from(document.querySelectorAll('[data-gf-gallery-item]')).map(btn => ({
        src: btn.querySelector('img') ? btn.querySelector('img').src : '',
        alt: btn.querySelector('img') ? btn.querySelector('img').alt || '' : '',
        button: btn
    }));

    if (!items.length) return;

    // prevent duplicate binding on modal controls
    if (!modal.dataset.gfLbInit) modal.dataset.gfLbInit = '1';
    let current = 0;
    let previouslyFocused = null;

    function render(index) {
        current = index;
        viewport.innerHTML = '';
        const img = document.createElement('img');
        img.src = items[index].src;
        img.alt = items[index].alt || '';
        img.className = 'gf-lightbox__img';
        viewport.appendChild(img);
        caption.textContent = items[index].alt || '';
        if (btnPrev) btnPrev.disabled = index === 0;
        if (btnNext) btnNext.disabled = index === items.length - 1;
    }

    function setAriaHidden(hidden) {
        Array.from(document.body.children).forEach(ch => {
            if (ch === modal) return;
            ch.setAttribute('aria-hidden', hidden ? 'true' : 'false');
        });
    }

    function trapFocus(e) {
        const focusables = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.key === 'Tab') {
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        } else if (e.key === 'Escape') {
            close();
        } else if (e.key === 'ArrowLeft') {
            prev();
        } else if (e.key === 'ArrowRight') {
            next();
        }
    }

    function open(index) {
        previouslyFocused = document.activeElement;
        render(index);
        modal.classList.remove('is-hidden');
        // trigger any CSS open animation with a frame
        requestAnimationFrame(() => modal.classList.add('is-open'));
        modal.setAttribute('aria-hidden', 'false');
        // setAriaHidden(true);
        const focusTarget = modal.querySelector('button, [tabindex]:not([tabindex="-1"])') || modal;
        focusTarget.focus();
        // Remove first to prevent stacking
        document.removeEventListener('keydown', trapFocus);
        document.addEventListener('keydown', trapFocus);
    }

    function close() {
        modal.classList.remove('is-open');
        const onEnd = () => {
            modal.classList.add('is-hidden');
            modal.setAttribute('aria-hidden', 'true');
            // setAriaHidden(false);
            modal.removeEventListener('transitionend', onEnd);
        };
        modal.addEventListener('transitionend', onEnd);
        document.removeEventListener('keydown', trapFocus);
        if (previouslyFocused && previouslyFocused.focus) previouslyFocused.focus();
    }

    function prev() {
        if (current > 0) render(current - 1);
    }
    function next() {
        if (current < items.length - 1) render(current + 1);
    }

    // attach click/keyboard to gallery items (mark bound to avoid duplicates)
    items.forEach((item, i) => {
        const btn = item.button;
        if (btn.dataset.gfLbBound) return;
        btn.dataset.gfLbBound = '1';
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            open(i);
        });
        btn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                open(i);
            }
        });
    });

    // modal controls (bind once)
    if (!modal.dataset.gfLbControlsBound) {
        modal.querySelectorAll('[data-gf-lightbox-close]').forEach(el => el.addEventListener('click', close));
        const backdrop = modal.querySelector('.gf-lightbox__backdrop');
        if (backdrop) backdrop.addEventListener('click', close);
        if (btnPrev) btnPrev.addEventListener('click', prev);
        if (btnNext) btnNext.addEventListener('click', next);
        modal.dataset.gfLbControlsBound = '1';
    }

    // show/hide next/prev based on item count
    const hasMultiple = items.length > 1;
    if (btnPrev) btnPrev.style.display = hasMultiple ? '' : 'none';
    if (btnNext) btnNext.style.display = hasMultiple ? '' : 'none';
}